import { render, staticRenderFns } from "./ShippinFeeList.vue?vue&type=template&id=31a29ad1"
import script from "./ShippinFeeList.js?vue&type=script&lang=js&external"
export * from "./ShippinFeeList.js?vue&type=script&lang=js&external"
import style0 from "./ShippinFeeList.vue?vue&type=style&index=0&id=31a29ad1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports